import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchFilter1' })
export class SearchFilterPipe1 implements PipeTransform {
  transform(list: any[], filterText: string): any {
    if ((list === null && list.length < 1) || filterText === '' || filterText === undefined) {
      return list;
    }
    return list ? list.filter(item => item.tigger_title.toLowerCase().search(new RegExp(filterText.toLowerCase(), 'i')) > -1) : [];
  }
}
